import { render, staticRenderFns } from "./CaseGroups.vue?vue&type=template&id=45b41765&"
import script from "./CaseGroups.vue?vue&type=script&lang=js&"
export * from "./CaseGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports